<template>
  <div class="modal-change popup" id="modal-change3">
    <h2 class="modal-change__title">ОСТАВИТЬ ОТЗЫВ</h2>
    <form class="modal-change__form" @submit.prevent="Submit()">
      <label for="#modal-input1" class="modal-change__label">Имя:</label>
      <input
        type="text"
        class="modal-change__input"
        id="modal-input1"
        v-model="fullname"
      />
      <!--  -->
      <label for="#modal-input2" class="modal-change__label">Ваш отзыв:</label>
      <textarea class="modal-change__textarea" v-model="description"></textarea>
      <!--  -->
      <button class="modal-change__save order-form__change">
        Оставить отзыв
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
//
export default {
  name: "AddReviewModal",
  props: ["modal", "bg"],

  data: () => ({
    fullname: "",
    description: ""
  }),

  methods: {
    ...mapActions("modals", ["closeModal"]),
    ...mapActions("reviews", ["addReview"]),

    Submit() {
      this.addReview({
        fullname: this.fullname,
        description: this.description
      }).then(response => {
        this.closeModal("add-review");
        alert("Спасибо за отзыв!");
      });
    }
  }
};
</script>

<style>
.popup {
  z-index: 1000;
  display: block;
  width: 330px;
  max-height: 700px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  margin: 0 !important;
}

.popup__message {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Modals/AddReview.vue